import { render, staticRenderFns } from "./VersionInformation.vue?vue&type=template&id=74c4829b"
import script from "./VersionInformation.vue?vue&type=script&lang=js"
export * from "./VersionInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports